import * as React from 'react';

import PropTypes from 'prop-types';

import styles from './ProductInfoTiles.module.css';

export const getColorFromType = (cannabisType) => {
  const type = cannabisType ? cannabisType.toLowerCase() : ''; 
  if (type.indexOf('indica') > -1) {
    return '#3c84d4';
  } else if (type.indexOf('hybrid') > -1) { 
    return '#54a40a';
  } else if (type.indexOf('sativa') > -1) {  
    return '#da9c03';
  } else if (type.indexOf('cbd') > -1) {
    return '#8239bf';
  }  
  return 'var(--zrBlack)';
}

const unitSymbolMap = new Map([
  ['percentage','%'],
  ['milligrams', 'mg'],
  ['milligrams_per_gram', 'mg/g']
]);

const ProductInfoText = ({
  thcVal,
  thcUnits,
  cbdVal,
  cbdUnits,
  cannabisType
}) => {
 
  // Exclude zero values
  const validThcValue = parseInt(thcVal,10) > 0;
  const validCbdValue = parseInt(cbdVal,10) > 0;

  const thcLabel = validThcValue ? `${thcVal}${unitSymbolMap.get(thcUnits) || ''}` : null;
  const cbdLabel = validCbdValue ? `${cbdVal}${unitSymbolMap.get(cbdUnits) || ''}` : null;
  
  return (
    <ol className={styles.infoText}> 
      { cannabisType &&
        <li className={styles.typeLabel} style={{ color: getColorFromType(cannabisType) }}>
          {cannabisType}
        </li>
      }

      { thcLabel && 
        <li>
          <span className={styles.label}>THC</span>: 
          <span className={styles.value}>{thcLabel}</span>
        </li> 
      }

      { cbdLabel &&
        <li> 
          <span className={styles.label}>CBD</span>: 
          <span className={styles.value}>{cbdLabel}</span>
        </li> 
      } 
    </ol>  
  );
}

ProductInfoText.propTypes = {
  thcVal: PropTypes.string,
  thcUnits: PropTypes.string,
  cbdVal: PropTypes.string,
  cbdUnits: PropTypes.string,
  cannabisType: PropTypes.string,
}

export default  ProductInfoText;